import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-18331ae8")

_pushScopeId("data-v-18331ae8")
const _hoisted_1 = { class: "flex flex-row mt-3" }
const _hoisted_2 = { class: "responsive-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DetailStatusCardDashboardClient = _resolveComponent("DetailStatusCardDashboardClient")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_CardDashboardClient = _resolveComponent("CardDashboardClient")!

  return (_openBlock(), _createBlock(_component_CardDashboardClient, {
    class: "my-4",
    title: _ctx.$t('dashboard.status')
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DetailStatusCardDashboardClient, {
            class: "responsive-width",
            title: _ctx.$t(_ctx.totalStatusDelivery.title),
            tooltipTitle: _ctx.$t(_ctx.totalStatusDelivery.tooltip),
            loading: _ctx.totalStatusDelivery.loading,
            value: _ctx.totalStatusDelivery.value
          }, null, 8, ["title", "tooltipTitle", "loading", "value"]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deliveryPerStatus, (statusDelivery) => {
            return (_openBlock(), _createBlock(_component_DetailStatusCardDashboardClient, {
              class: "responsive-width",
              key: statusDelivery,
              title: _ctx.$t(statusDelivery.title),
              tooltipTitle: _ctx.$t(statusDelivery.tooltip),
              loading: statusDelivery.loading,
              value: statusDelivery.value,
              ableToClick: statusDelivery.ableToClick,
              color: statusDelivery.color,
              onClick: ($event: any) => (_ctx.onClickDetail(`status-${statusDelivery.type}`))
            }, {
              default: _withId(() => [
                _createVNode(_component_ProgressBar, {
                  value: 
              _ctx.valueProgressBar(statusDelivery.value, _ctx.totalStatusDelivery.value)
            ,
                  class: "w-full mr-2",
                  startValue: 0,
                  endValue: _ctx.totalStatusDelivery.value,
                  customColor: statusDelivery.color
                }, null, 8, ["value", "endValue", "customColor"])
              ]),
              _: 2
            }, 1032, ["title", "tooltipTitle", "loading", "value", "ableToClick", "color", "onClick"]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})